<template>
  <div>
    <div class="register-container">
      <img style="width: 100%" src="../assets/topbg.png" />
      <div
        style="
          margin-top: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <img style="width: 50%" src="../assets/CREATE.png" alt="CREATE Image" />
      </div>
      <div class="content">
        <van-form validate-first @failed="onFailed">
          <!-- 手机号 -->
          <div class="box">
            <p class="zi">phone</p>
            <div class="put">
              <van-field
                label-width="36px"
                label="+91"
                v-model="memberPhone"
                type="tel"
                placeholder="Your phone number"
                :rules="[
                  {
                    pattern: /^[6-9]\d{9}$/,
                    message: 'Please enter a valid phone number',
                  },
                ]"
              />
            </div>
          </div>

          <!-- 密码 -->
          <div class="box">
            <p class="zi">Password</p>
            <div class="put">
              <van-field
                v-model="memberPwd"
                :type="passwordType"
                placeholder="Your password"
                :rules="[
                  {
                    pattern: passwordPattern,
                    message: '8-16 chars, upper/lowercase & numbers required',
                  },
                ]"
              >
                <template slot="right-icon">
                  <span class="solts" @click="switchPasswordType">
                    <van-icon
                      :name="passwordType === 'text' ? 'eye' : 'closed-eye'"
                    />
                  </span>
                </template>
              </van-field>
            </div>
          </div>

          <!-- 确认密码 -->
          <div class="box">
            <p class="zi">Password Again</p>
            <div class="put">
              <van-field
                v-model="memberPwdAgain"
                :type="passwordType1"
                placeholder="Confirm your password"
                :rules="[
                  {
                    validator: validatePasswordMatch,
                    message: 'Passwords do not match',
                  },
                ]"
              >
                <template slot="right-icon">
                  <span class="solts" @click="switchPasswordType1">
                    <van-icon
                      :name="passwordType1 === 'text' ? 'eye' : 'closed-eye'"
                    />
                  </span>
                </template>
              </van-field>
            </div>
          </div>

          <!-- 邀请码 -->
          <div class="box">
            <p class="zi">Invite Code</p>
            <div class="put">
              <van-field
                v-model="inviteCode"
                disabled
                class="custom-green-text"
              />
            </div>
          </div>

          <!-- 验证码 -->
          <div class="box">
            <p class="zi">Verification Code</p>
            <div class="put">
              <van-field
                v-model="smsCode"
                type="digit"
                placeholder="Enter verification code"
              >
                <template slot="button">
                  <van-button
                    size="small"
                    round
                    color="#66CC33"
                    style="min-width: 70px; font-weight: bold; border: none"
                    :disabled="countdown > 0 || !isValidPhone || isSendingSms"
                    @click="handleSmsButtonClick"
                  >
                    <span style="color: #fff">{{
                      countdown > 0 ? `${countdown}s` : "Send"
                    }}</span>
                  </van-button>
                </template>
              </van-field>
            </div>
          </div>
        </van-form>

        <van-button
          @click="doRegister"
          style="
            margin-top: 40px;
            height: 48px;
            font-weight: bold;
            font-size: 24px;
            border-radius: 12px;
          "
          color="#66CC33"
          block
          :disabled="isDisabled"
          >SIGN IN</van-button
        >

        <p style="margin-top: 24px; text-align: center; color: #66cc33">
          Already have an account?
        </p>
      </div>

      <!-- 加载遮罩 -->
      <van-overlay :show="show" @click="show = false">
        <div class="wrapper">
          <van-loading type="spinner" color="#1989fa" />
        </div>
      </van-overlay>
    </div>

    <!-- 注册成功弹窗 -->
    <van-popup round style="width: 90%" v-model="success">
      <div class="dialog-content">
        <div class="title-container">
          <div class="title"><span>Registration successful</span></div>
        </div>
        <p class="ds">Download the APP and start your journey</p>
        <div class="app-icon">
          <img src="../assets/Spro Deal-i@2x.png" />
          <p>Spro Deal</p>
        </div>
        <van-button color="#282c38" class="vb" @click="downloadApp">
          <span style="font-weight: 600; color: #fff; font-size: 18px"
            >Download app</span
          >
        </van-button>
      </div>
    </van-popup>

    <!-- 阿里云验证码挂载点 -->
    <div id="aliyun-captcha-element"></div>
  </div>
</template>

<script>
import { register, sendSms, getSceneId } from "@/api";
import { Button } from "vant";
import Vue from "vue";
Vue.use(Button);
import { Popup } from "vant";
Vue.use(Popup);
import { Field } from "vant";
Vue.use(Field);
import { Form } from "vant";
Vue.use(Form);
import { Icon } from "vant";
Vue.use(Icon);
import { Image as VanImage } from "vant";
Vue.use(VanImage);
import { Loading } from "vant";
import { Overlay } from "vant";
Vue.use(Overlay);
Vue.use(Loading);
import { Notify } from "vant";
Vue.use(Notify);
import { Toast } from "vant";
Vue.use(Toast);

export default {
  data() {
    return {
      memberPhone: "",
      memberPwd: "",
      memberPwdAgain: "",
      passwordType: "password",
      passwordType1: "password",
      inviteCode: "",
      downloadLink: "",
      passwordPattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,16}$/,
      show: false,
      success: false,
      smsCode: "",
      countdown: 0,
      timer: null,
      captchaInstance: null,

      isSendingSms: false,
    };
  },
  computed: {
    isValidPhone() {
      return /^[6-9]\d{9}$/.test(this.memberPhone);
    },
    isDisabled() {
      return (
        !this.isValidPhone ||
        !this.passwordPattern.test(this.memberPwd) ||
        this.memberPwd !== this.memberPwdAgain ||
        !this.smsCode
      );
    },
  },
  created() {
    // 存放验证码实例，非响应式
    this.captchaInstance = null;
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted() {
    this.inviteCode = this.$route.query.inviteCode || "";
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    // 1. 点击“发送”按钮触发的逻辑
    async handleSmsButtonClick() {
      // 1. 拦截：如果手机号无效、倒计时中、或者正在请求中，直接返回
      if (!this.isValidPhone || this.countdown > 0 || this.isSendingSms) return;

      // 2. 加锁：马上设为 true，防止二次点击
      this.isSendingSms = true; 

      this.$toast.loading({ message: "Initializing...", duration: 0 });

      try {
        // 1. 全局配置保持和 App 同事一致
        window.AliyunCaptchaConfig = {
          region: "sgp",
          prefix: "juhu36b",
        };

        // 2. 获取后端加密场景 ID
        const res = await getSceneId(
          { requestSource: "WH" },
          { packageName: "com.nh.spro.deal" },
        );
        const encryptedId = res.data?.sceneId || res.sceneId;

        // 3. 确保脚本已加载
        if (!window.initAliyunCaptcha) {
          await this.loadCaptchaScript();
        }

        // 4. 【核心修复】如果已有实例，先销毁，防止挂载点被占用
        if (this.captchaInstance) {
          try {
            this.captchaInstance = null;
          } catch (e) {
            console.warn("Destroy old instance failed", e);
          }
        }

        // 3. 初始化验证码
        window.initAliyunCaptcha({
          SceneId: "6vz9hadip", // 【注意】建议换成 App 同事那个能跑通的 ID
          EncryptedSceneId: encryptedId,
          mode: "popup",
          element: "#aliyun-captcha-element",
          language: "en",
          immediate: false,
          success: (captchaVerifyParam) => {
            this.executeSendSms(captchaVerifyParam);
          },
          fail: (result) => {
            console.error("Captcha fail:", result);
          },
          errorCallback: (err) => {
            // 这里的网络报错 ERR_CONNECTION_CLOSED 只是背景收集数据失败，
            // 只要 success 触发了，就不必理会这里的报错
            console.warn(
              "Captcha background network error (Safe to ignore if success fired):",
              err,
            );
          },
          getInstance: (instance) => {
            this.captchaInstance = instance;
            this.$toast.clear();

            // 3. 解锁：验证码弹窗实例已经准备好了，解除连点限制
            this.isSendingSms = false; 

            // 6. 【核心修复】确保实例获取后立即调用 show()
            if (
              this.captchaInstance &&
              typeof this.captchaInstance.show === "function"
            ) {
              console.log("Instance ready, showing popup...");
              this.captchaInstance.show();
            } else {
              this.$toast.fail("Captcha init failed");
            }
          },
        });
      } catch (err) {
        // 4. 解锁：如果接口报错或者js加载失败，必须解除锁定，让用户可以重试
        this.isSendingSms = false; 
        this.$toast.clear();
        this.$notify({ type: "danger", message: "Init Error" });
      }
    },
    async executeSendSms(captchaVerifyParam) {
      try {
        this.$toast.loading({
          message: "Sending SMS...",
          forbidClick: true,
          duration: 0,
        });
        console.log("sendSms:", captchaVerifyParam);
        const res = await sendSms(
          {
            memberPhone: this.memberPhone,
            codeType: "5",
            captchaVerifyParam: captchaVerifyParam,
            requestSource: "WH",
          },
          { packageName: "com.nh.spro.deal" },
        );
        console.log("sendSms res:", res);
        if (res) {
          this.$toast.success("Sent successfully");
          this.startCountdown(); // 只有成功才启动倒计时
        } else {
          // 如果后端返回 600，会走到这里，不启动倒计时
          this.$notify({
            type: "danger",
            message: res.message || "Captcha validation failed on server",
          });
        }
      } catch (err) {
        console.error("SMS API Error:", err);
        this.$notify({ type: "danger", message: err.message });
      } finally {
        this.$toast.clear();
      }
    },

    // 辅助：加载脚本
    loadCaptchaScript() {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src =
          "https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js";
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    // 3. 验证通过后的回调：执行发短信业务
    async captchaVerifyCallback(captchaVerifyParam) {
      console.log("captchaVerifyParam:", captchaVerifyParam);
      try {
        this.$toast.loading({
          message: "Sending SMS...",
          forbidClick: true,
          duration: 0,
        });

        // 调用后端发送短信接口，传入验证参数
        const res = await sendSms(
          {
            memberPhone: this.memberPhone,
            codeType: "5",
            captchaVerifyParam: captchaVerifyParam, // 关键：将验证码结果传给后端
            requestSource: "WH",
          },
          { packageName: "com.nh.spro.deal" },
        );

        if (res && (res.status == 200 || res.code == 200)) {
          this.$toast.success("Sent successfully");
          this.startCountdown();
          return { captchaResult: true, bizResult: true };
        } else {
          throw new Error(res.message || "Failed to send SMS");
        }
      } catch (err) {
        this.$notify({ type: "danger", message: err.message });
        // 返回 bizResult: true 是为了让验证码弹窗正常关闭，不强制重试
        return { captchaResult: true, bizResult: true };
      } finally {
        this.$toast.clear();
      }
    },

    // 2. 倒计时逻辑
    startCountdown() {
      console.log("Countdown started...");
      this.countdown = 60;
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    // 注册逻辑
    doRegister() {
      this.show = true;
      const params = {
        memberPhone: this.memberPhone,
        memberPwd: this.memberPwd,
        memberPwdAgain: this.memberPwdAgain,
        inviteCode: this.inviteCode,
        verificationCode: this.smsCode,
      };

      register(params, { packageName: "com.nh.spro.deal" })
        .then((res) => {
          if (res.downloadLink) {
            this.success = true;
            this.downloadLink = res.downloadLink;
          } else {
            this.$notify({ type: "warning", message: res.message });
          }
        })
        .catch((err) => {
          this.$notify({ type: "warning", message: err.message });
        })
        .finally(() => {
          this.show = false;
        });
    },

    validatePasswordMatch(val) {
      return val === this.memberPwd;
    },
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    switchPasswordType1() {
      this.passwordType1 =
        this.passwordType1 === "password" ? "text" : "password";
    },
    downloadApp() {
      window.open(this.downloadLink, "_blank");
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    goToLogin() {
      this.$router.push("/login");
    },
  },
};
</script>
<style scoped>
/* 原有 CSS 保持完全一致 */
.register-container {
  padding-bottom: 60px;
}
.content {
  padding: 0 30px;
}
.box {
  margin-top: 20px;
}
.zi {
  font-family: Source Sans Variable;
  font-weight: 600;
  color: #666666;
  margin-bottom: 12px;
}
.van-cell {
  background: rgba(109, 181, 254, 0);
  border-radius: 15px;
  border: 1px solid #eeeeee;
}
/deep/ .van-field__label {
  font-family: Source Sans Variable;
  font-weight: bold;
  font-size: 15px;
  color: #666666;
}
.van-button__text {
  color: #000;
}
/deep/ .van-field__control {
  font-family: Source Sans Variable;
  font-weight: 600;
  color: #111111;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.success-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  color: white;
  text-align: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.success-icon {
  font-size: 80px;
  color: #4caf50;
  margin-bottom: 20px;
}

.success-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 16px;
}

.success-description {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 40px;
}

.confetti {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #ffeb3b;
  top: -10%;
  animation: confetti-fall 5s linear infinite;
}

.confetti:nth-child(2) {
  background-color: #f44336;
  left: 20%;
  animation-delay: 1s;
}

.confetti:nth-child(3) {
  background-color: #2196f3;
  left: 40%;
  animation-delay: 2s;
}

.confetti:nth-child(4) {
  background-color: #4caf50;
  left: 60%;
  animation-delay: 3s;
}

.confetti:nth-child(5) {
  background-color: #ff9800;
  left: 80%;
  animation-delay: 4s;
}

@keyframes confetti-fall {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  100% {
    transform: translateY(100vh) rotate(720deg);
  }
}
.dialog-content {
  text-align: center;
  padding: 20px;
}

.app-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.app-icon img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}
.title-container {
  width: 100%;
  padding-top: 20px;
}

.title {
  font-size: 1.3rem;
  position: relative;
  display: inline-block;
  color: #000;
}

.title span {
  display: inline-block;
  position: relative;
  z-index: 1;
}

.title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%;
  background-color: #66cc33;
  z-index: 0;
}
.ds {
  margin-top: 12px;
  color: #8d8d8d;
  font-size: 12px;
}
.vb {
  width: 100%;
  border-radius: 12px;
}
.custom-green-text ::v-deep .van-field__control:disabled {
  color: #66cc33;
  -webkit-text-fill-color: #66cc33;
}
</style>
